export enum StepKey {
  APPLIANCE_DETAILS = 'applianceDetails',
  MODEL_SERIAL = 'modelSerial',
  PURCHASE_PRICE = 'purchasePrice',
  ARRIVAL_DATE = 'purchaseDate',
  PERSONAL_DETAILS = 'personalDetails',
}
